import React, { memo } from "react";
import Div from "../../common/ui/Div";
import { LogoRound } from "../../common/ui/Logo";
import { ResponsiveDeviceType } from "../../layouts/ScreenMedia";
import Center from "../../common/ui/Center";
import { SpacingHeight } from "../../common/ui/Spacing";
import { TextBlock } from "../../common/ui/Text";
import { textCase } from "../../../service/ui/UI";
import AppConfigService from "../../../service/app_config/AppConfigService";

const BranchLogoName = (props: {
  logo: string;
  name: string;
  type?: number;
  size?: number;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  return (
    <Div>
      <Center>
        <LogoRound
          url={props.logo || AppConfigService.get("company_logo")}
          size={props.size ?? (type === 3 ? 180 : 90)}
          name={props.name}
        />
      </Center>
      <SpacingHeight value={18} />
      <TextBlock
        center={true}
        fontSize="20_21"
        fontName="medium"
        textColor="them-label"
      >
        {textCase(props.name)}
      </TextBlock>
    </Div>
  );
};

export default memo(BranchLogoName);
